var _Box;
import React from 'react';
import { Box } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FallbackContainerAuthStaffLogin() {
  return _Box || (_Box = /*#__PURE__*/_jsx(Box, {}));
}